import template from './bargain.jade';
import validation from './../../../services/validation';

export default angular
  .module('cian.addForm.bargain', [])
  .directive('cianAfPriceAndDealTermsBargain', ['categoryService', categoryService => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: ['$scope', 'deviceService', function ($scope, deviceService) {
      this.isMobile = deviceService.isMobile;
      if (!this.ad.bargainTerms) {
        this.ad.bargainTerms = {};
      }

      const isBargainAllowed = () => {
        return this.ad.bargainTerms.bargainAllowed || (angular.isDefined(this.ad.bargainTerms.bargainPrice) && this.ad.bargainTerms.bargainPrice !== null) || angular.isString(this.ad.bargainTerms.bargainConditions);
      };

      this.ad.bargainTerms = this.ad.bargainTerms || {};
      this.ad.bargainTerms.bargainAllowed = isBargainAllowed();

      this.validation = validation(this.form, 'bargain.bargainConditions', {
        maxlength: 'Превышено ограничение',
      });

      const categoryInfo = categoryService.getInfoByCategory(this.ad.category);
      this.bargainPricePeriod = (categoryInfo.propertyType !== 'commercial') ? 'в месяц' : '';

      $scope.$watch(() => this.ad.bargainTerms.bargainAllowed, (newValue, oldValue) => {
        if (newValue === false && oldValue === true) {
          if (this.ad.bargainTerms.bargainConditions) {
            delete this.ad.bargainTerms.bargainConditions;
          }
          if (this.ad.bargainTerms.bargainPrice) {
            delete this.ad.bargainTerms.bargainPrice;
          }
        }
      });
    }],
    controllerAs: 'bargain',
    template,
  })])
  .name;
